import { createElementBlock as r, openBlock as o, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(c, e) {
  return o(), r("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 1.936a5.14 5.14 0 1 0 0 10.28 5.14 5.14 0 0 0 0-10.28M7.926 4.502a3.64 3.64 0 1 1 5.148 5.148 3.64 3.64 0 0 1-5.148-5.148",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M7.18 15.855a6.1 6.1 0 0 1 3.32-1.006c1.155 0 2.298.343 3.32 1.006 1.023.663 1.893 1.627 2.517 2.81a.75.75 0 0 0 1.326-.7c-.734-1.393-1.773-2.556-3.027-3.369a7.6 7.6 0 0 0-4.136-1.247 7.6 7.6 0 0 0-4.136 1.247c-1.254.813-2.293 1.976-3.027 3.368a.75.75 0 0 0 1.326.7c.624-1.182 1.494-2.146 2.517-2.81"
    }, null, -1)
  ])]);
}
const d = { render: t };
export {
  d as default,
  t as render
};
